import { Trans, useTranslation } from 'react-i18next'

import MyMarkdown from './Markdown.tsx'

export const Hints = () => {
  const { t } = useTranslation()
  return (
    <>
      <h3 className="h1">{t('hints.notesTitle')}</h3>
      <ol>
        <li>{t('hints.note2')}</li>
        <li>{t('hints.note3')}</li>
        <li>{t('hints.note4')}</li>
        <li>
          <MyMarkdown markdown={t('hints.note5')} />
        </li>

        <li>{t('hints.note6')}</li>
      </ol>
      <hr />
      <h3 className="h1">{t('hints.limitationsTitle')}</h3>
      <p>
        <Trans i18nKey="hints.limitationsText">
          SomeGPT weiss (fast) alles, was auf
          <a href={import.meta.env.VITE_MAIN_SITE_LINK} target={'_blank'}>
            SomeURL.ch
          </a>
          publiziert war.
        </Trans>
      </p>
      <p>{t('hints.disclaimerText')}</p>
    </>
  )
}
